import { Link } from 'gatsby';
import React from 'react';
import { ItemsGrid, ItemStyles } from '../styles/Grids';

const ItemGrid = ({ items, baseUrl }) => (
  <ItemsGrid>
    {items.map((item) => (
      <ItemStyles key={item._id}>
        <p>
          <span className="mark">
            <Link to={`${baseUrl}/${item.slug.current}`}>{item.name}</Link>
          </span>
        </p>
        <img
          height="400"
          width="500"
          src={`${item.image.asset.url}?w=500&h=400&fit=crop`}
          alt={item.name}
          style={{
            background: `url(${item.image.asset.metadata.lqip})`,
            backgroundSize: 'cover',
          }}
        />
      </ItemStyles>
    ))}
  </ItemsGrid>
);
export default ItemGrid;
